import * as network from "./network";

const getMasterSwitchStatus =()=>{
    return network.get(`masterswitch`);
  };

  export default{
      getMasterSwitchStatus,
  }